import { Fragment } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import conditionsData from '../conditions.json'
import HeroSection from '../components/common/HeroSection';
import DigitalHealthFAB from '../components/Digitalhealth';
/* ─── Inline SVG icon map ─── */
const Icon = ({ name, size = 18, color = 'currentColor', strokeWidth = 1.8 }) => {
    const props = { width: size, height: size, fill: 'none', stroke: color, strokeWidth, viewBox: '0 0 24 24' };
    const icons = {
        brain: <svg {...props}><path d="M12 5a3 3 0 10-5.997.125 4 4 0 00-2.526 5.77 4 4 0 00.556 6.588A4 4 0 1012 19v-2" strokeLinecap="round" strokeLinejoin="round" /><path d="M12 5a3 3 0 115.997.125 4 4 0 012.526 5.77 4 4 0 01-.556 6.588A4 4 0 1112 19v-2" strokeLinecap="round" strokeLinejoin="round" /></svg>,
        heart: <svg {...props}><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" /></svg>,
        zap: <svg {...props}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>,
        moon: <svg {...props}><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" strokeLinecap="round" strokeLinejoin="round" /></svg>,
        activity: <svg {...props}><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" /></svg>,
        alert: <svg {...props}><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" strokeLinecap="round" /><line x1="12" y1="16" x2="12.01" y2="16" strokeLinecap="round" /></svg>,
        cloud: <svg {...props}><path d="M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z" /></svg>,
        battery: <svg {...props}><rect x="1" y="6" width="18" height="12" rx="2" ry="2" /><line x1="23" y1="13" x2="23" y2="11" strokeLinecap="round" /><line x1="4" y1="12" x2="8" y2="12" strokeLinecap="round" /></svg>,
        'eye-off': <svg {...props}><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" strokeLinecap="round" /><line x1="1" y1="1" x2="23" y2="23" strokeLinecap="round" /></svg>,
        frown: <svg {...props}><circle cx="12" cy="12" r="10" /><path d="M16 16s-1.5-2-4-2-4 2-4 2" strokeLinecap="round" /><line x1="9" y1="9" x2="9.01" y2="9" strokeLinecap="round" /><line x1="15" y1="9" x2="15.01" y2="9" strokeLinecap="round" /></svg>,
        clock: <svg {...props}><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>,
        shuffle: <svg {...props}><polyline points="16 3 21 3 21 8" /><line x1="4" y1="20" x2="21" y2="3" /><polyline points="21 16 21 21 16 21" /><line x1="15" y1="15" x2="21" y2="21" /><line x1="4" y1="4" x2="9" y2="9" /></svg>,
        rewind: <svg {...props}><polygon points="11 19 2 12 11 5 11 19" /><polygon points="22 19 13 12 22 5 22 19" /></svg>,
        refresh: <svg {...props}><polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" /><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" strokeLinecap="round" /></svg>,
        message: <svg {...props}><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" /></svg>,
        pill: <svg {...props}><path d="M10.5 20H4a2 2 0 01-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 011.66.9l.82 1.2a2 2 0 001.66.9H20a2 2 0 012 2v5" strokeLinecap="round" /><circle cx="17" cy="17" r="5" /><path d="M14 17h6M17 14v6" strokeLinecap="round" /></svg>,
        user: <svg {...props}><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" strokeLinecap="round" /><circle cx="12" cy="7" r="4" /></svg>,
        users: <svg {...props}><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" strokeLinecap="round" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" strokeLinecap="round" /></svg>,
        leaf: <svg {...props}><path d="M11 20A7 7 0 014.93 7c2.76-2.55 6.3-3.96 10.07-4 4 0 8 4 8 8-1.07 3.34-4.4 6.15-8 6.15-2.83 0-5.5-1.52-7-4.15" strokeLinecap="round" /><path d="M2 21c3.39-3 5.5-5.97 5.5-10" strokeLinecap="round" /></svg>,
        sun: <svg {...props}><circle cx="12" cy="12" r="5" /><line x1="12" y1="1" x2="12" y2="3" strokeLinecap="round" /><line x1="12" y1="21" x2="12" y2="23" strokeLinecap="round" /><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" strokeLinecap="round" /><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" strokeLinecap="round" /><line x1="1" y1="12" x2="3" y2="12" strokeLinecap="round" /><line x1="21" y1="12" x2="23" y2="12" strokeLinecap="round" /><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" strokeLinecap="round" /><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" strokeLinecap="round" /></svg>,
        'trending-up': <svg {...props}><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>,
        'trending-down': <svg {...props}><polyline points="23 18 13.5 8.5 8.5 13.5 1 6" /><polyline points="17 18 23 18 23 12" /></svg>,
        check: <svg {...props}><polyline points="20 6 9 17 4 12" /></svg>,
        shield: <svg {...props}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeLinecap="round" strokeLinejoin="round" /></svg>,
        arrow: <svg {...props}><line x1="5" y1="12" x2="19" y2="12" strokeLinecap="round" /><polyline points="12 5 19 12 12 19" /></svg>,
        home: <svg {...props}><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>,
        chevron: <svg {...props}><polyline points="9 18 15 12 9 6" /></svg>,
    };
    return icons[name] || icons['alert'];
};

const ConditionDetails = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const conditon = conditionsData.conditions?.conditions.find(c => c.slug === slug);
    if (!conditon) {
        return (
            <div className="flex flex-col items-center justify-center py-24 gap-4">
                <p className="ava-heading-lg text-gray-500">Condition not found.</p>
                <button onClick={() => navigate('/conditions')} className="btn-primary px-6 py-2 rounded-md ava-text-sm">
                    Back to Conditions
                </button>
            </div>
        )
    }
    const d = conditon.detail;
    const slidesCondition = [{
        "id": "ConditionDetail Hero",
        "image":`${d.img}`,
        "alt": "condition details",
        "headingStrong": `${d.heroHeadingStrong}`,
        "headingSub": `${d.heroHeadingHighlight}`,
        "description": `${d.heroDescription}`,
        "cta": {
            "primary": {
                "label": `${d.heroCta.primary.label}
                `,
                "href": `${d.heroCta.primary.href}`
            },
            // "secondary": {
            //     "label": `${d.heroCta.secondary.label}`,
            //     "href": `${d.heroCta.secondary.href}`
            // }
        }
    }]
    return (
        <Fragment>
            {/* Here I have to add hero section */}
            <DigitalHealthFAB/>
            <HeroSection slides={slidesCondition} />
            <section className="ava-section-gap px-6 max-w-6xl mx-auto">
                <h2 className=" ava-heading-lg ava-heading-gap " 
                // style={{ fontSize: 'clamp(1.1rem, 2vw, 1.4rem)', color: 'var(--primary-color)' }}
                >
                    {d.symptoms.heading}
                </h2>
                <p className="ava-text-sm mb-6" >{d.symptoms.subheading}</p>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                    {d.symptoms.items.map((item, i) => (
                        <div
                            key={i}
                            className="flex flex-col items-center  text-center gap-2 ava-radius-md p-4 ava-card-mukta"
                            style={{
                                background: '#fff',
                                // border: '0.5px solid #e2eaf5' 

                            }}
                        >
                            <div
                                className="w-16 h-16 rounded-full ava-light-surface flex items-center justify-center mb-1"
                            // style={{ background: '#ffedea' }}
                            >
                                <Icon name={item.icon} size={28} color={'var(--primary-color)'} strokeWidth={1.8} />
                            </div>
                            <p className="font-semibold ava-text-xs " >{item.name}</p>
                            <p className="ava-text-xs " >{item.detail}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── When to Seek Help + How We Treat (2-col) ── */}
            <div className='ava-card-bg ava-section-gap'>
                <section className=" px-6 max-w-6xl mx-auto">

                    <div className="text-center  ava-heading-gap">
                        <h2 className="ava-heading-lg">
                            We're here for you{' '}
                            <span style={{ color: 'var(--secondary-color)' }}>🤍</span>
                        </h2>
                        <p className="ava-text-sm mt-2" style={{ color: 'var(--text-secondary)' }}>
                            Personalized care for every stage of your health journey.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">

                        {/* ── Left Card ── */}
                        <div
                            className="ava-card-mukta ava-radius-md flex flex-col overflow-hidden "
                            style={{
                                background: 'white',
                                // boxShadow: '0 4px 24px 0 rgba(99,120,180,0.10), 0 1.5px 6px 0 rgba(99,120,180,0.07)',
                            }}
                        >
                            <div className="px-7 pt-7 pb-5 flex flex-col flex-1">

                                {/* Icon + Heading */}
                                <div className="flex items-center gap-4">
                                    <div
                                        className="flex-shrink-0 flex items-center justify-center rounded-full"
                                        style={{ background: '#EAF1FF', minWidth: 53, minHeight: 53, width: 53, height: 53 }}
                                    >
                                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" strokeWidth="1.8">
                                            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" strokeLinecap="round" strokeLinejoin="round" />
                                            <line x1="12" y1="9" x2="12" y2="13" strokeLinecap="round" />
                                            <line x1="12" y1="17" x2="12.01" y2="17" strokeLinecap="round" />
                                        </svg>
                                    </div>
                                    <div className="flex-1">
                                        <h3 className="ava-text-subheading">{d.whenToSeekHelp.heading}</h3>
                                        <div style={{ height: 1.5, background: 'var(--primary-color)', opacity: 0.15, borderRadius: 2, marginTop: 6 }} />
                                    </div>
                                </div>

                                <p style={{ paddingLeft: 70 }} className="ava-text-xs mb-4">{d.whenToSeekHelp.subheading}</p>

                                {/* Checklist — icon has circular bg, divider indented past icon */}
                                <ul className="flex-1" style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                                    {d.whenToSeekHelp.items.slice(0, 4).map((item, i) => (
                                        <div key={i}>
                                            <li className="flex items-center gap-3 py-3 ava-text-sm">
                                                {/* Circular bg around check */}
                                                <div
                                                    className="flex-shrink-0 flex items-center justify-center rounded-full"
                                                    style={{ background: '#EAF1FF', minWidth: 32, minHeight: 32, width: 32, height: 32 }}
                                                >
                                                    <Icon name="check" size={16} color="var(--primary-color)" strokeWidth={2.5} />
                                                </div>
                                                {item}
                                            </li>
                                            {i < d.whenToSeekHelp.items.length - 1 && (
                                                // Divider indented to start after the icon (32px icon + 12px gap = 44px)
                                                <div style={{ height: 1, background: '#e5e7eb', marginLeft: 44 }} />
                                            )}
                                        </div>
                                    ))}
                                </ul>
                            </div>

                            {/* Bottom banner */}

                        </div>

                        {/* ── Right Card ── */}
                        <div
                            className="ava-radius-md flex flex-col overflow-hidden relative ava-card-mukta"
                            style={{
                                background: 'white',
                                // boxShadow: '0 4px 24px 0 rgba(180,99,120,0.10), 0 1.5px 6px 0 rgba(180,99,120,0.07)',
                            }}
                        >
                            {/* Decorative blob */}
                            <div
                                className="absolute pointer-events-none"
                            // style={{
                            //     bottom: -40, right: -40,
                            //     width: 200, height: 200,
                            //     background: 'radial-gradient(circle, #fcd8e6 0%, transparent 70%)',
                            //     borderRadius: '50%',
                            // }}
                            />

                            <div className="px-7 pt-7 pb-7 flex flex-col flex-1 relative" style={{ zIndex: 1 }}>

                                {/* Icon + Heading */}
                                <div className="flex items-center gap-4 ">
                                    <div
                                        className="flex-shrink-0 flex items-center justify-center rounded-full"
                                        style={{ background: '#fbd8e4', minWidth: 53, minHeight: 53, width: 53, height: 53 }}
                                    >
                                        <Icon name="heart-handshake" size={28} color="var(--secondary-color)" strokeWidth={1.8} />
                                    </div>
                                    <div className="flex-1">
                                        <h3 className="ava-text-subheading" style={{ color: 'var(--secondary-color)' }}>
                                            {d.howWetreat.heading}
                                        </h3>
                                        <div style={{ height: 1.5, background: 'var(--secondary-color)', opacity: 0.25, borderRadius: 2, marginTop: 6 }} />
                                    </div>
                                </div>

                                <p style={{ paddingLeft: 70 }} className="ava-text-xs mb-2">{d.howWetreat.subheading}</p>

                                {/* Treatment items — icon in pink circle, divider indented past icon */}
                                <div className="flex-1">
                                    {d.howWetreat.items.map((item, i) => (
                                        <div key={i}>
                                            <div className="flex items-center gap-4 py-4">
                                                <div
                                                    className="flex-shrink-0 flex items-center justify-center rounded-full"
                                                    style={{ background: '#fbd8e4', minWidth: 32, minHeight: 32, width: 32, height: 32 }}
                                                >
                                                    <Icon name='check' size={16} color="var(--secondary-color)" strokeWidth={2.5} />
                                                </div>
                                                <div>
                                                    <p className="font-semibold ava-text-sm">{item.title}</p>
                                                    <p className="ava-text-xs mt-0.5">{item.description}</p>
                                                </div>
                                            </div>
                                            {i < d.howWetreat.items.length - 1 && (
                                                // Divider indented to start after the icon (52px icon + 16px gap = 68px)
                                                <div style={{ height: 1, background: '#e5e7eb', marginLeft: 68 }} />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
            {/* ── Related Care Options ── */}
            <section className="ava-section-gap px-6 max-w-6xl mx-auto">
                <h2 className="mb-1 ava-heading-md " 
                >
                    {d.relatedCare.heading}
                </h2>
                <p className="ava-text-sm mb-6" >{d.relatedCare.subheading}</p>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {d.relatedCare.items.map((item, i) => (
                        <div
                            key={i}
                            className="flex flex-col gap-2 ava-card-mukta  ava-radius-md p-4 cursor-pointer transition-all duration-150"
                            style={{ background: '#fff', }}
                            // onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--primary-color)'; e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.06)'; }}
                            // onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--ava-color-primary-50)'; e.currentTarget.style.boxShadow = 'none'; }}
                        >
                            <div
                                className="w-16 h-16 rounded-full flex items-center justify-center ava-card-bg"
                            >
                                <Icon name={item.icon} size={25} color="var(--primary-color)" strokeWidth={1.8} />
                            </div>
                            <p className="font-semibold ava-text-sm" >{item.title}</p>
                            <p className="ava-text-xs" >{item.description}</p>
                            <button
                                className="flex items-center gap-1 ava-text-xs font-semibold mt-1 transition-colors duration-150"
                                
                                onClick={() => navigate('#')}
                            >
                                Learn more
                                <Icon name="arrow" size={11} color="var(--primary-color)" strokeWidth={2.5} />
                            </button>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── CTA Banner ── */}
            <section className="ava-section-gap px-6 max-w-6xl mx-auto">
                <div
                    className="relative flex flex-col ava-card-bg sm:flex-row items-center justify-between gap-6 ava-radius-md overflow-hidden px-6 py-8 sm:px-8 ava-card-mukta"
                   
                >
                    {/* Blob — hidden on mobile */}
                    <div
                        className="hidden sm:block absolute left-0 top-0 bottom-0 w-32 pointer-events-none"
                    />

                    {/* Text */}
                    <div className=" flex flex-col  gap-2 flex-1 text-center sm:text-left">
                        <h3
                            className="ava-heading-md "
                        >
                            {d.ctaBanner.heading}
                        </h3>
                        <p
                            className="ava-text-sm mx-auto sm:mx-0"
                            style={{ 
                                 maxWidth: '380px' }}
                        >
                            {d.ctaBanner.subheading}
                        </p>
                    </div>

                    {/* CTA */}
                    <div className="flex shrink-0 flex-col items-center gap-2 sm:items-end">
                        <button
                            onClick={() => navigate(d.ctaBanner.buttonHref)}
                            className="flex items-center gap-2 btn-primary flex-shrink-0 transition-all duration-200"
                            style={{
                                // background: 'var(--primary-color)',
                                // color: 'white',
                                // // fontSize: 'clamp(0.78rem, 1.2vw, 0.9rem)',
                                // padding: '12px 24px',
                            }}
                        >
                            {d.ctaBanner.buttonLabel}
                            <Icon name="arrow" size={14} color="white" strokeWidth={2.5} />
                        </button>
                        <p className="flex items-center gap-1.5 ava-text-xs mt-1" >
                            <Icon name="check" size={12} color="var(--primary-color)" strokeWidth={2.5} />
                            {d.ctaBanner.note}
                        </p>
                    </div>
                </div>
            </section>

        </Fragment>
    )
}

export default ConditionDetails